import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth_reducer'
import app from './app';

export default combineReducers({
  app,
  form: formReducer,
  auth: authReducer
});